var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#ffffff",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#ffffff;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M203.364,2.333c-11.788,0-19.73,9.352-19.73,20.873v99.422c0,11.306-5.814,16.714-14.728,16.714 c-8.142,0-12.945-6.717-12.945-14.692L155.517,21.37C155.517,8.338,144.144,0,133.59,0c-10.558,0-21.926,8.338-21.926,21.37V124.65 c0,7.976-5.252,14.692-13.395,14.692c-8.903,0-14.721-5.408-14.721-16.714V23.206c0-11.521-7.943-20.873-19.731-20.873 c-11.797,0.02-18.08,10.173-19.359,20.131c-1.279,9.967-7.825,81.147-8.542,126.64c-0.727,45.504,31.216,72.117,49.414,80.571 c12.442,5.779,21.448,18.207,21.448,33.154L99.334,512h68.509l-7.444-249.171c0-14.946,9-27.374,21.443-33.154 c18.202-8.454,50.146-35.067,49.423-80.571c-0.722-45.493-7.258-116.673-8.547-126.64C221.434,12.506,215.157,2.353,203.364,2.333z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M378.422,3.935c-47.398,0-97.68,50.57-97.68,130.008c0,45.504,34.389,82.446,49.424,95.732 c14.702,13.004,21.448,18.207,21.448,33.154L344.17,512h68.509l-7.449-249.171c0-14.946,6.756-20.15,21.458-33.154 c15.014-13.287,49.408-50.228,49.408-95.732C476.097,54.505,425.82,3.935,378.422,3.935z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeal);
export default __webpack_public_path__ + "static/media/meal.cc88922fcf278b67da4729ffc3335659.svg";
export { ForwardRef as ReactComponent };